import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { AccountDebtLineDTO } from '../../dto/HonorariumLiquidationDTO';
import { formatDateOnly } from '../../utils/date';
import { formatMoney } from '../../utils/money';

interface AccountDebtLinesProps {
    lines: AccountDebtLineDTO[];
}

/**
 * Deudas de la cuenta corriente que el cierre le descuenta al profesional, cada una con su origen ("Pago de más · OP N°
 * 7", "Retenciones por facturación propia · Liquidación N° 18"), para que se entienda de dónde sale la deuda.
 */
export default function AccountDebtLines({ lines }: AccountDebtLinesProps) {
    return (
        <DataTable value={lines} className="crudTable" emptyMessage="Sin deuda en cuenta corriente.">
            <Column header="Fecha" body={(row: AccountDebtLineDTO) => formatDateOnly(row.date)} style={{ width: '120px' }} />
            <Column header="Origen" field="label" />
            <Column
                header="Se descuenta"
                body={(row: AccountDebtLineDTO) => formatMoney(row.amount)}
                className="text-right"
                headerClassName="col-right"
                style={{ width: '170px' }}
            />
        </DataTable>
    );
}
